// @mui
import { AnimatePresence } from 'framer-motion';
// utils
//
//
import { UploadProps } from '../types';
import { MultiFileItemPreview } from './MultiFileItemPreview';

export default function MultiFilePreview({
  thumbnail,
  files,
  onRemove,
  onDownload,
  sx,
  sxRemove,
}: UploadProps) {
  if (!files?.length) {
    return null;
  }

  return (
    <AnimatePresence initial={false}>
      {files.map((file, index) => (
        <MultiFileItemPreview
          key={index}
          file={file}
          thumbnail={thumbnail}
          onDownload={onDownload}
          onRemove={onRemove}
          sx={sx}
          sxRemove={sxRemove}
        />
      ))}
    </AnimatePresence>
  );
}
